import { action, reaction, computed, decorate, observable } from "mobx";
import axios from "axios";
import moment from "moment";
import defaultTranslations from "./defaultTranslations.json";
import sffjs from "sffjs";

require("moment/locale/nl-be.js");
require("moment/locale/en-gb.js");
require("moment/locale/fr.js");

class TranslationsStore {
  constructor(rootStore, baseUrl) {
    this.rootStore = rootStore;

    if (!this.rootStore) throw new Error("rootStore cannot be null");

    this.baseUrl = baseUrl;
    this.translations = defaultTranslations;
    this.language = null;

    this.watchLanguageChange = reaction(
      () => this.fullLanguage,
      language => {
        console.log(`language changed to ${language}`);
        moment.locale(language);
        sffjs.setCulture(language);
        this.fetch(language);
      }
    );

    this.language = navigator && navigator.language ? navigator.language : "en";
  }

  get fullLanguage() {
    let l = this.language;
    if (l) {
      const lowerCase = l.toLowerCase();
      if (lowerCase === "nl") l = "nl-be";
      else if (lowerCase === "en") l = "en-gb";
      else if (lowerCase === "fr") l = "fr";
    }
    return l;
  }

  updateFromJSON(json) {
    this.translations = json;
  }

  fetch(language) {
    if (this.baseUrl) {
      const url = `${this.baseUrl}/${language}`;
      console.log(`fetching: ${url}`);
      axios
        .get(url)
        .then(
          function(response) {
            console.log(`received: ${url}`);
            this.updateFromJSON(response.data);
          }.bind(this)
        )
        .catch(function(error) {
          console.dir(error);
        });
    } else {
      console.log(
        "No baseUrl specified for TranslationsStore, unable to fetch data"
      );
    }
  }
}

decorate(TranslationsStore, {
  translations: observable,
  language: observable,
  fullLanguage: computed,
  updateFromJSON: action
});

export default TranslationsStore;



// WEBPACK FOOTER //
// ./src/Core/Stores/TranslationsStore/index.js